module.exports = {"name":"DiscussionsPersistentForums","parameters":[{"name":"DiscussionsPersistentForumsEnabled","value":true}]}